module.exports = __webpack_public_path__ + "img/spin_btn.091aad8c.png";